import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import {ApiBaseUrl, SnackbarOptions} from './../../../../constants';
import { useAuth } from "./../../../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import {useSnackbar} from 'react-simple-snackbar'
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement
} from "@stripe/react-stripe-js";


const useOptions = () => {
    const options = useMemo(
        () => ({
            style: {
                base: {
                    fontSize:"16px",
                    color: "#ffffff",
                    letterSpacing: "0.025em"
                },
                invalid: {
                    color: "#cc0000"
                }
            }
        }),[]
    );

    return options;
};

const SplitForm = (props) => {
    const [openSnackbar] = useSnackbar(SnackbarOptions)
    let history = useHistory();
    const {token} = useAuth();
    const bearerToken = token;
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();

    const handleSubmit = async event => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        /*const payload = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardNumberElement)
        });
        console.log("[PaymentMethod]", payload);
        */
        const {error, token} = await stripe.createToken(
            elements.getElement(CardNumberElement)
        );

        if(error) {
            openSnackbar(error.message);
            return;
        }

        const paymentBody = 'id='+props.id+'&paytoken='+token.id;
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/shared_reserve",
            {
                method: 'POST',
                body: paymentBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+bearerToken
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success){

                    }
                    else{
                        openSnackbar(result.message);
                        history.replace(process.env.PUBLIC_URL+'/oneday/entry-pass/'+result.data._id);
                        //history.replace(process.env.PUBLIC_URL+'/oneday/my-purchased-deals');

                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {

                }
            )
        );
    };

    return (
        <div className="row">
            <div className="col-lg-7 col-md-7 col-12 px--xs-0">
                <form autoComplete="off" onSubmit={handleSubmit} className="card-form-solid">
                    <div className="ro">
                        <div className="payment-container">
                            <div className="payment-box">

                                <div className="new-card-add-row">
                                    <p className="text-white">Enter card details</p>
                                    <div className="row">
                                        {/*<div className="col-xl-12">
                                            <div className="new_card_number">
                                                <div className="card_img">
                                                    <img src={`${process.env.PUBLIC_URL}/image/cart-cart-img-1.png`} alt="card"/>
                                                </div>
                                                <span className="card-num">Card Number</span>
                                            </div>
                                        </div>*/}
                                        <div className="col-xl-12">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <CardNumberElement options={options}/>
                                                </div>
                                                <div className="col-lg-8 col-12 col-md-12">
                                                    <CardExpiryElement options={options}/>
                                                </div>
                                                <div className="col-lg-4 col-12 col-md-12">
                                                    <CardCvcElement className="w-100" options={options}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-lg-right text-center">
                                            <div className="cart_pay">
                                                <button disabled={!stripe} className="grad-on pay_cart_btn text-uppercase font-weight-bold" type="submit">Pay</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="col-lg-5 col-md-5 col-12 px--xs-0">
                <div className="payment-detail-box">
                    <div className="card-deposite-outer grad-on">
                        <div className="card-deposite-cols card_reserve_deal">
                            <p>Pay deposit to Reserve Deal: <span
                                className="pl-3 font-weight-bold  reserve_deposit">${props.consumer_order_cost-props.consumerprice}</span></p>
                        </div>

                        <div className="card-deposite-cols card-deposite-right">
                            <p>Full Price :<span
                                className="pl-3 font-weight-bold card_price">${props.consumer_order_cost}</span></p>
                        </div>
                        <div className="card-deposite-cols card-deposite-right">
                            <p>Still Owed :<span
                                className="pl-3 font-weight-bold card_price">${props.consumerprice}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SplitForm;
